<!-- 提取明细 -->
<template>
  <div class="container">
    <div class="mainFooter">
      <div class="left">查询关键词：</div>
      <el-input
        size="small"
        style="width: 2rem; margin-right: 0.1rem"
        placeholder="请输入提取订单编号"
      ></el-input>
      <el-date-picker
        size="small"
        style="margin-right: 0.1rem"
        type="daterange"
        range-separator="至"
        start-placeholder="操作开始日期"
        end-placeholder="操作结束日期"
      >
      </el-date-picker>
      <el-select style="margin-right: 0.1rem;width: 1.7rem;" size="small" v-model="value" placeholder="收入类型">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="margin-right: 0.1rem;width: 1.7rem;" size="small" v-model="value" placeholder="支出类型">
        <el-option
          v-for="item in options1"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div style="display:flex;align-items:center;margin-left: auto;">
           <el-button style="color:#ED7046" size="small">重置</el-button>
           <el-button style="color:#ED7046" size="small">搜索</el-button>
      </div>
    </div>
    <p class="p3">
      符合条件共：订单（ <span>0个</span> ）金额（ <span>0¥</span> ）
    </p>
    <el-table
      border
      header-align="center"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column align="center" prop="orderNumber" label="订单号">
      </el-table-column>
      <el-table-column align="center" prop="createName" label="订单发起人">
      </el-table-column>
      <el-table-column align="center" prop="address" label="订单时间">
        <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatHms }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="describe" label="事由">
      </el-table-column>
      <el-table-column align="center" label="收支类型">
        <template slot-scope="scope">
            {{ payMode[scope.row.source] }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="address" label="金额">
        <template slot-scope="scope">
            {{ scope.row.price + '¥' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props:{
    tableData:{
      type:Array,
      default:[]
    },
  },
  data() {
    return {
      payMode:{
        0:'微信 ',
        1:'支付宝',
        2:'余额',
        3:'线下转账'
      },
      value:'',
      options: [
        {
          value: "选项1",
          label: "完成任务兑换收入",
        },
        {
          value: "选项2",
          label: "平台劵未使用退款收入",
        },
      ],
      options1: [
        {
          value: "选项1",
          label: "平台使用费",
        },
        {
          value: "选项2",
          label: "购买平台劵",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
   
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
   .mainFooter {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
    background-color: #f3f3f3;
    padding: 0.15rem;
    .left {
      font-size: 0.12rem;
    }
  }
  .p3 {
    margin-bottom: 0.24rem;
    span {
      color: #dc7039;
      font-weight: bold;
    }
  }
}
</style>
